import React from 'react'
import { useMutation } from '@apollo/client'
import { Button } from '@winnin/winnin_ui.components.button'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'
import { useToast } from '@winnin/winnin_ui.components.toast'

import { useDashboardModals } from 'contexts/DashboardModalsContext'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS, analyticsTracker, captalizeFirstLetter } from 'utils'

import { DELETE_DASHBOARD_MUTATION } from './query'
import './index.scss'
import TOLGEE_KEYS from './translate'

const { DELETE_JOB, CLOSE_MODAL } = analyticsTracker.eventNames

const MODAL_STYLE = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.80)',
    overflowY: 'overlay',
    zIndex: 999,
  },
  content: {
    width: '80%',
    maxWidth: '564px',
    position: 'absolute',
    top: '50%',
    right: 'unset',
    left: '50%',
    bottom: 'unset',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: 'var(--spacing_unit_6)',
    overflow: 'unset',
    borderRadius: '8px',
  },
}

export default function DeleteDashboardModal() {
  const t = useTranslate()
  const { createToast } = useToast()
  const { dashboard, setDashboard, isDeleteDashboardModalOpen, setIsDeleteDashboardModalOpen } = useDashboardModals()

  const { jobType } = dashboard

  const [deleteDashboard, { loading }] = useMutation(DELETE_DASHBOARD_MUTATION, {
    onCompleted({ editWorkspaceJob }) {
      const capitalizedJobType = captalizeFirstLetter(jobType)
      setDashboard({})
      setIsDeleteDashboardModalOpen(false)

      analyticsTracker.eventTrack(DELETE_JOB, {
        'Job Name': editWorkspaceJob?.name,
        'Job ID': editWorkspaceJob?.id,
      })

      createToast({
        content: t(TOLGEE_KEYS.successfullyDeletedToast({ jobType: capitalizedJobType, jobName: dashboard?.name })),
      })
    },
    refetchQueries: [
      'workspaceJobsWithFoldersPaginated',
      'addToGetWorkspaceJobsPaginated',
      'getListWorkspaceJobPaginated',
    ],
    onError(error) {
      console.error('DeleteDashboardModal @ deleteDashboard', error)

      createToast({
        content: t(TOLGEE_GLOBALS.requestProblem),
      })
    },
  })

  function handleCloseModal() {
    analyticsTracker.eventTrack(CLOSE_MODAL, {
      modalType: 'Job Delete',
    })

    setDashboard({})
    setIsDeleteDashboardModalOpen(false)
  }

  const handleDeleteButtonClick = () => {
    deleteDashboard({
      variables: {
        workspaceJobInput: {
          id: dashboard?.id,
          isActive: false,
        },
      },
    })
  }

  return (
    <Modal
      isOpen={isDeleteDashboardModalOpen}
      style={MODAL_STYLE}
      onRequestClose={handleCloseModal}
      appElement={document.body}
    >
      <div className="DeleteDashboardModal">
        <Title tag="h3">{t(TOLGEE_KEYS.modalTitle({ jobType }))}</Title>

        <p className="DeleteDashboardModal-text">{t(TOLGEE_KEYS.modalDescriptionLabel({ jobType }))}</p>

        <div className="DeleteDashboard-footer">
          <Button onClick={handleCloseModal} variation="faded" appearance="link">
            {t(TOLGEE_GLOBALS.cancel)}
          </Button>
          <Button onClick={handleDeleteButtonClick} disabled={loading}>
            {t(TOLGEE_GLOBALS.exclude)}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
